module.exports = __webpack_public_path__ + "static/media/w_w_hr_35.798b3bb9.png";